import { createStyles, makeStyles } from "@material-ui/core/styles";
import { HEIGHT_FOOTER } from "config/constant";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				height: `calc(100vh - ${HEIGHT_FOOTER}px)`,
				overflow: "scroll",
				position: "relative"
			},
			bgUser: {
				background: `linear-gradient(180deg, ${theme.palette.primary.light} 10%,#fff 70%, #fff 100%)`,
				padding: "35px 35px 7px"
			},
			avatar: {
				textAlign: "center",
				"&& > img": {
					borderRadius: "50%",
					objectFit: "cover",
					border: `3px solid ${theme.palette.common.white}`
				}
			},
			userName: {
				color: theme.palette.primary.contrastText,
				fontWeight: "bold",
				fontSize: 16
			},
			level: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				padding: 5
			},
			bgLevel: {
				padding: "2px 15px",
				color: theme.palette.common.white,
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				borderRadius: 30,
				border: `1px solid ${theme.palette.common.white}`,
				fontSize: 12,
				"&& > img": {
					marginRight: 5
				}
			},
			bodyMenu: {
				background: theme.palette.common.white,
				padding: "0px 15px",
				marginBottom: 10,
				boxShadow: "0px 3px 29px rgba(114, 136, 128, 0.15)"
			},
			name: {
				fontWeight: 500,
				fontSize: 16
			},
			title: {
				padding: "15px 0px 10px",
				color: theme.palette.primary.contrastText
			},
			border: {
				borderTop: `1px solid ${theme.palette.grey[800]}`
			}
		}),
	{
		name: "UserPage",
		index: 1
	}
);

export default useStyles;
